import { z } from 'zod';
import { dataResponse, errorCodeResponse, errorResponse, successResponse } from './utils/response-templates.js';
import { ErrorCodes } from './error-codes.js';
const invitationPasswordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters long')
    .max(100, 'Password must be no longer than 100 characters')
    .regex(/^.*[0-9].*$/, 'Password must include at least one number')
    .regex(/^.*[a-z].*$/, 'Password must include at least one lowercase letter')
    .regex(/^.*[A-Z].*$/, 'Password must include at least one uppercase letter');
export const createInvitationDtoSchema = z.object({
    email: z.string().commonEmail(),
});
export const invitedByDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const invitedByPublicDtoSchema = z.object({
    name: z.string(),
    company: z.string().optional(),
});
export const invitationDtoSchema = z.object({
    id: z.string(),
    invitedById: z.string(),
    createAt: z.string().datetime(),
    updateAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    acceptedAt: z.string().datetime().nullable(),
    email: z.string(),
    status: z.string(),
    invitedBy: invitedByDtoSchema.nullable(),
});
export const invitationPublicDtoSchema = z.object({
    id: z.string(),
    email: z.string(),
    status: z.string(),
    invitedBy: invitedByPublicDtoSchema.nullable(),
});
export const createInvitationResponseSchema = dataResponse(invitationDtoSchema);
export const updateInvitationRequestSchema = createInvitationDtoSchema.partial();
export const listInvitationsResponseSchema = dataResponse(z.array(invitationDtoSchema));
export const getInvitationResponseSchema = dataResponse(invitationDtoSchema);
export const getInvitationPublicResponseSchema = dataResponse(invitationPublicDtoSchema);
export const existingOrganizationMemberResponseSchema = errorResponse('User is already a member');
export const updateInvitationResponseSchema = dataResponse(invitationDtoSchema);
export const acceptInvitationRequestSchema = z.object({
    name: z.string().trim().min(1),
    id: z.string(),
    code: z.string(),
    password: invitationPasswordSchema.optional(),
});
export const acceptInvitationResponseSchema = successResponse().extend({
    token: z.string(),
});
export const invalidCodeResponseSchema = errorResponse('Invalid code');
export const invitationMaxUsersErrorResponseSchema = errorCodeResponse(ErrorCodes.EOrganizationLimit, 'Max users reached for your organization');
export const invitationResendThrottleErrorResponseSchema = errorCodeResponse(ErrorCodes.EInvitationResendThrottleReached, 'Cannot resend invitation yet (EInvitationResendThrottleReached)');
